import { FC } from 'react';
import { ProInput } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { NewInputProps } from '../antd/Input/input';
import { FormInstance } from 'antd/lib/form';

interface FormInputProps extends Omit<NewInputProps, 'onChange'> {
  onChange?: (value: any, record?: any, form?: FormInstance<any>) => void;
}

export interface SimpleFormInputProps extends BaseSimpleFormProps {
  inputProps?: FormInputProps;
}
const simpleFormInput: FC<SimpleFormInputProps> = props => {
  const { disabledRender, inputProps = {}, form, ...restProps } = props;
  return (
    <SimpleFormItem {...restProps}>
      {inputProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          render={disabledRender}
        />
      ) : (
        <ProInput {...inputProps} />
      )}
    </SimpleFormItem>
  );
};

simpleFormInput.displayName = SimpleFormItemEnum.SimpleFormInput;

export default simpleFormInput;
